import { useEffect, useRef } from 'react';
import Lottie from 'react-lottie';

export default function LottieAnimation({
  animationData,
  width = 200,
  height = 200,
  loop = true,
  autoplay = true,
  speed = 1,
  className = '',
  // 'slice' fills + crops (default, unchanged); 'meet' fits the whole frame.
  preserveAspectRatio = 'xMidYMid slice',
}) {
  const lottieRef = useRef(null);

  useEffect(() => {
    if (lottieRef.current && speed !== 1) {
      const anim = lottieRef.current.anim;
      if (anim) {
        anim.setSpeed(speed);
      }
    }
  }, [speed]);

  const defaultOptions = {
    loop,
    autoplay,
    animationData,
    rendererSettings: {
      preserveAspectRatio,
    },
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Lottie
        options={defaultOptions}
        height={height}
        width={width}
        ref={lottieRef}
      />
    </div>
  );
}
